import { createSlice } from "@reduxjs/toolkit";

export const databaseSlice = createSlice({
    name: "database",
    initialState: {classes: {}, settings: {homework:"https://fwparker.myschoolapp.com/podium/feed/iCal.aspx?z=qRHeq4eSEKl49Vhw4x9RyQS7VaQZksoR8uZ4o3eoFTKEYy0cs%2bfwaIXejeqIQySbMXJ7yVxIvgiSed2AG0U3VQ%3d%3d"}, version: 0},
    reducers: {
        setDatabase: (state, action) => {
            return action.payload;
        },
        setSettings : (state, action) => {
            state.settings = action.payload;
            return state;
        },
        setGCConfig : (state, action) => {
            state.settings.gcconfig = action.payload;
            return state;
        },
        setClasses : (state, action) => {
            state.classes = action.payload;

            return state;
        },
        setVersion : (state, action) => {
            state.version = action.payload;

            return state;
        }
    },
});

export const { setDatabase, setSettings, setClasses, setVersion, setGCConfig } = databaseSlice.actions;
